// ReporteControlContrasenas.tsx

import React, { useEffect, useState } from 'react';
import { Button, Form, Table, Badge, Card, Row, Col } from 'react-bootstrap';
import { ReporteControlContrasena } from './DTO/ReporteControlContrasena';
import ControlContrasenasService from '../../../Services/Catalogos/CatSistemas'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver';
import { BsSearch, BsFileEarmarkExcel, BsChatLeftTextFill } from "react-icons/bs";



interface Props {
    refreshKey: number;
    onSeleccionarEmpleado?: (numEmpleado: string) => void;
}


// const ReporteControlContrasenas = ({ refreshKey }: Props) => {

const ReporteControlContrasenas = ({ refreshKey, onSeleccionarEmpleado }: Props) => {
    const [data, setData] = useState<ReporteControlContrasena[]>([]);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [estatus, setEstatus] = useState('TODOS');
    const [loading, setLoading] = useState(false);

    const cargarReporte = async () => {
        try {
            setLoading(true);

            const res = await ControlContrasenasService.GetReporteControlContrasenas(
                fechaInicio || undefined,
                fechaFin || undefined,
                estatus
            );

            setData(res.data);
        } catch (error) {
            console.error('Error al cargar reporte de contraseñas:', error);
        } finally {
            setLoading(false);
        }
    };

    


    useEffect(() => {
    cargarReporte();
}, [refreshKey]);
    


    const badgeEstatus = (estatus: string) => {
        switch (estatus) {
            case 'VENCIDA':
                return <Badge bg="danger">VENCIDA</Badge>;
            case 'POR VENCER':
                return <Badge bg="warning" text="dark">POR VENCER</Badge>;
            case 'AL DIA':
                return <Badge bg="success">AL DÍA</Badge>;
            default:
                return <Badge bg="secondary">{estatus}</Badge>;
        }
    };

    const formatDate = (fecha?: string | null) => {
        if (!fecha) return 'Sin actualización';
        return new Date(fecha).toLocaleDateString('es-MX');
    };



    const descargarExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Reporte');

    worksheet.columns = [
        { header: '#', key: 'index', width: 8 },
        { header: 'Empleado', key: 'numEmpleado', width: 15 },
        { header: 'Nombre', key: 'nombreEmpleado', width: 35 },
        { header: 'Departamento', key: 'departamento', width: 30 },
        { header: 'Tipo', key: 'tipoContrasena', width: 18 },
        { header: 'Última actualización', key: 'fechaUltimaActualizacion', width: 22 },
        { header: 'Vencimiento', key: 'fechaVencimiento', width: 18 },
        { header: 'Estatus', key: 'estatus', width: 15 }
    ];

    const datosOrdenados = [...data].sort((a, b) =>
        String(a.numEmpleado || '').localeCompare(
            String(b.numEmpleado || ''),
            undefined,
            { numeric: true, sensitivity: 'base' }
        )
    );

    datosOrdenados.forEach((item, index) => {
        worksheet.addRow({
            index: index + 1,
            numEmpleado: String(item.numEmpleado || ''),
            nombreEmpleado: item.nombreEmpleado,
            departamento: item.departamento,
            tipoContrasena: item.tipoContrasena,
            fechaUltimaActualizacion: formatDate(item.fechaUltimaActualizacion),
            fechaVencimiento: formatDate(item.fechaVencimiento),
            estatus: item.estatus
        });
    });

    worksheet.getColumn('numEmpleado').eachCell((cell, rowNumber) => {
        if (rowNumber > 1) {
            cell.numFmt = '@';
            cell.value = String(cell.value || '');
        }
    });

    worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } };
    worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF212529' }
    };

    worksheet.getRow(1).alignment = {
        vertical: 'middle',
        horizontal: 'center'
    };

    worksheet.eachRow((row) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
    });

    worksheet.autoFilter = {
        from: 'A1',
        to: 'H1'
    };

    worksheet.views = [{ state: 'frozen', ySplit: 1 }];

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    saveAs(blob, `Reporte_Control_Contrasenas_${new Date().toISOString().slice(0, 10)}.xlsx`);
};








    

    return (
        <Card className="shadow-sm border-0 mt-3">
            {/* <Card.Header className="bg-dark text-white">
                <strong>Reporte de control de contraseñas</strong>
            </Card.Header> */}

            <Card.Body>
                <Row className="mb-3 g-2">
                    <Col md={3}>
                        <Form.Label>Fecha inicio</Form.Label>
                        <Form.Control
                            type="date"
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Fecha fin</Form.Label>
                        <Form.Control
                            type="date"
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                        />
                    </Col>

                    <Col md={3}>
                        <Form.Label>Estatus</Form.Label>
                        <Form.Select
                            value={estatus}
                            onChange={(e) => setEstatus(e.target.value)}
                        >
                            <option value="TODOS">Todos</option>
                            <option value="AL DIA">Al día</option>
                            <option value="POR VENCER">Por vencer</option>
                            <option value="VENCIDA">Vencida</option>
                        </Form.Select>
                    </Col>

                    <Col md={1} className="d-flex align-items-end">
                        <Button
                            variant="primary"
                            className="w-100"
                            onClick={cargarReporte}
                            disabled={loading}
                        >
                            {loading ? 'Buscando...' : 'Buscar'}
                        </Button>
                    </Col>


                     <Col md={1} className="d-flex align-items-end">
        <Button
            variant="outline-success"
            className="w-100"
            onClick={descargarExcel}
            disabled={data.length === 0}
        >
        <BsFileEarmarkExcel /> Excel
        </Button>
    </Col>
                </Row>

                <div className="table-responsive">
                    <Table striped bordered hover size="sm" className="align-middle">
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Empleado</th>
                                <th>Nombre</th>
                                <th>Departamento</th>
                                {/* <th>Oficina</th> */}
                                <th>Tipo</th>
                                <th>Última actualización</th>
                                <th>Vencimiento</th>
                                <th>Estatus</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.length === 0 ? (
                                <tr>
                                    <td colSpan={9} className="text-center text-muted">
                                        No hay registros para mostrar.
                                    </td>
                                </tr>
                            ) : (
                                data.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        {/* <td>{item.numEmpleado}</td> */}
                                        <tr
    key={item.id}
    style={{ cursor: "pointer" }}
    onClick={() => onSeleccionarEmpleado?.(item.numEmpleado)}
>
    <td>{item.numEmpleado}</td>
    
    
</tr>
                                        
                                        <td>{item.nombreEmpleado}</td>
                                        <td>{item.departamento}</td>
                                        {/* <td>{item.oficina}</td> */}
                                        <td>{item.tipoContrasena}</td>
                                        <td>{formatDate(item.fechaUltimaActualizacion)}</td>
                                        <td>{formatDate(item.fechaVencimiento)}</td>
                                        <td>{badgeEstatus(item.estatus)}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ReporteControlContrasenas;